import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';
import platform, { OS_TYPES } from '../../../../../player/utils/platform';

const rule = ({ theme, width, height, isMobile }) => ({
  background: theme.color.thumbBackgroundColor,
  borderRadius: '50%',
  cursor: 'pointer',
  height: `${width}px`,
  width: `${height}px`,
  transform: 'translate(-50%, -50%)',
  position: 'absolute',
  top: '50%',
  transition: `width ${theme.transition.default}, height ${theme.transition.default}, background ${theme.transition.default}`,
  pointerEvents: 'none',
  zIndex: 2,
  extend: [
    {
      condition: isMobile,
      style: {
        background: theme.color.light,
      },
    },
  ],
});

const Thumb = React.forwardRef(({ className, width, height, ...otherProps }, ref) => {
  const isMobile = [OS_TYPES.IOS, OS_TYPES.ANDROID].includes(platform.os);
  const { css } = useFela({ width, height, isMobile });

  return (
    <div className={`${css(rule)} ${className}`} ref={ref} {...otherProps} />
  );
});

Thumb.displayName = 'Thumb';

Thumb.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
};

export default React.memo(Thumb);
